import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-3',
  templateUrl: './3.component.html',
  styleUrls: ['./3.component.scss'],
})
export class VbTablesBootstrap3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
